(function() {
  angular.module('previewBannerModule').component('previewBanner', {
    templateUrl: '/resources/components/preview-banner/preview-banner.component.html',
    controllerAs: 'vm',
    controller: [
      '$rootScope',
      '$scope',
      '$state',
      'authentication',
      'configuration',
      'classroomApi',
      'navigation',
      'edxPreviewBannerService',
      'edxUxPreferenceService',
      'dblAnalyticsProvider',
      PreviewBannerController
    ]
  });

  function PreviewBannerController($rootScope,
                                   $scope,
                                   $state,
                                   authentication,
                                   configuration,
                                   classroomApi,
                                   navigation,
                                   previewBannerService,
                                   uxPreferenceService,
                                   analyticsService) {

    $scope.hideNotification = hideNotification;
    $scope.makeEventAction = makeEventAction;

    uxPreferenceService.loadPreferences();
    var customerSubject = authentication.getCustomerSubject();

    customerSubject.subscribe(function (customer) {
      $scope.customer = customer;
      $scope.customerAnalyticsLabel = 'c' + customer.id;
      _selectBanner(customer);
    });

    /**
     * Selects a banner to show to user
     *
     * @param customer
     * @private
     */
    function _selectBanner(customer) {
      var banner = previewBannerService.findBestBannerForCustomer(customer);
      _setBanner(banner, customer);
    }

    /**
     * Sets the banner to show
     *
     * @param banner
     * @param customer
     * @private
     */
    function _setBanner(banner, customer) {
      if (banner) {
        $scope.bannerId = banner.id;
        $scope.bannerClass = banner.cssClass;
        if (banner.init) {
          banner.init(customer);
        }

        if (!previewBannerService.isBannerHidden()) {
          analyticsService.eventTrack('Banner Displayed ' + previewBannerService.getUserType(customer), {
            category: 'Banner',
            label: banner.id
          });
        }
      } else {
        $scope.bannerId = undefined;
        $scope.bannerClass = undefined;
      }
    }

    /**
     * Hides the banner
     */
    function hideNotification() {
      $rootScope.$emit('userClosedNotificationSet');
    }

    /**
     * Appends the user type to event action string.
     *
     * @param actionBase
     * @return {string}
     */
    function makeEventAction(actionBase) {
      return actionBase + ' ' + previewBannerService.getUserType($scope.customer);
    }

  }
})();
